<template>
    <div class="cooperation-manager">
        <p class="plugin-header">
            协作人员
        </p>
        <div class="map-cooperation">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    地图协作
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="cooperation-text">
                    地图协作成员可以管理全部数据
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="layer-cooperation">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    图层协作
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="cooperation-text">
                    图层协作成员仅能查看和编辑单个图层数据
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="feature-cooperation">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    记录协作
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="cooperation-text">
                    记录协作成员仅能查看和编辑单条记录数据
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CooperationManager',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.cooperation-manager {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    scrollbar-width: none;
}

.plugin-header {
    height: 36px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #edf0f5;
    line-height: 36px;
    color: #576d8b;
}

.map-cooperation:hover,.layer-cooperation:hover,.feature-cooperation:hover {
    border: 1px solid #0095ff;
    background-color: #fff; 
}

.map-cooperation, .layer-cooperation, .feature-cooperation {
    border: 1px solid transparent;
    position: relative;
    min-height: 110px;
    background-color: #fff;
    width: 282px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin-top: 12px;
    overflow: hidden;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
    min-height: auto;
}
.plugin-card-body {
    background: #edf0f5;
    background-color: transparent;
    padding: 10px;
    cursor: pointer;
    height: 32px;
}
.map-cooperation .plugin-card-body .plugin-card-title, .layer-cooperation .plugin-card-body .plugin-card-title, .feature-cooperation .plugin-card-body .plugin-card-title {
    position: relative;
    font-size: 14px;
    color: #576d8b;
    letter-spacing: 0;
    text-align: left;
    font-size: 16px;
}
.map-cooperation .plugin-card-footer, .layer-cooperation .plugin-card-footer, .feature-cooperation .plugin-card-footer {
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
}
.map-cooperation .plugin-card-footer p.cooperation-text, .layer-cooperation .plugin-card-footer p.cooperation-text, .feature-cooperation .plugin-card-footer p.cooperation-text {
    color: #576d8b;
    font-size: 12px;
}
.map-cooperation .plugin-card-footer p.cooperation-text span, .layer-cooperation .plugin-card-footer p.cooperation-text span, .feature-cooperation .plugin-card-footer p.cooperation-text span {
    line-height: 38px;
}
.pull-right {
    float: right !important;
}
</style>